import React from 'react'

import './footer.css'

function Footer() {
  return (
    <div className="bg-secondary">
        <div className="container-fluid">
            <div className='p-block'>
                <div className="footer-flex">
                    <div className="footer-form">
                        <p className="serif">JOIN OUR COMMUNITY</p>
                        <input type="text" placeholder='email'  required/>
                        <button type='submit' className='transition-slide btn btn-submit'>Join</button>
                    </div>
                    <div className="footer-links">
                        <p>About us</p>
                        <p>FAQ</p>
                        <p>Contact us</p>
                        <p>Privacy policy</p>
                        <p>Refund policy</p>
                        <p>Terms of service</p>
                        <p>How to order</p>
                        <p>Track your order</p>
                        <p>Returns & exchanges</p>
                    </div>
                </div>
                <p className='footer-p serif'>Lustore © 2022 All rights reserved!</p>
            </div>
        </div>
    </div>
  )
}

export default Footer